<script>
import { mapGetters } from "vuex";

import NewAddress from "@/components/_Shared/Addresses/NewAddress/Index";

export default {
  components: {
    NewAddress
  },

  data() {
    return {
      creating: false
    };
  },

  computed: {
    ...mapGetters("user", ["userType", "userAccountableId"])
  }
};
</script>

<template>
  <div class="address"  @click="creating = true">
    <span class="plus">+</span>
    <span class="text">Adicionar novo endereço</span>

    <NewAddress
      v-if="creating"
      :user="{ type: userType, id: userAccountableId }"
      @close="creating = false"
    />
  </div>
</template>

<style scoped>
.address {
  width: calc(100% - 24px - 24px);
  padding: 8px 12px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  color: #603285;
  background: #fff;
  border: solid 1px #e2e2e2;
  user-select: none;
  cursor: pointer;
}

.plus {
  font-size: 24px;
  font-weight: 400;
  margin-right: 8px;
}

.text {
  font-size: 15px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Address/NewAddress.vue